import React from 'react';

import { Grid, Typography } from '@mui/material';

const TnC = () => {
  return (
    <Grid sx={{ my: '4rem' }}>
      <Typography variant='h3' component='h1' sx={{ fontWeight: 'bold' }}>
        Terms & Conditions
      </Typography>
      <Typography variant='body1' sx={{ my: '2rem' }}>
        1. This card is to be used by The 100 Club members only and it is non-transferable.
      </Typography>
      <Typography variant='body1' sx={{ my: '2rem' }}>
        2. This card may be presented at the time of payment to our partnered establishments to receive perks and
        rewards
      </Typography>
      <Typography variant='body1' sx={{ my: '2rem' }}>
        3. By using this card, you agree to abide by The 100 Club membership terms and conditions.
      </Typography>
      <Typography variant='body1' sx={{ my: '2rem' }}>
        4. This card remains the property of The 100 Club and we reserve the right to cancel, terminate or suspend this
        membership card with or without any prior notice
      </Typography>
      <Typography variant='body1' sx={{ my: '2rem' }}>
        5. Any loss or theft is to be reported to The 100 Club immediately.
      </Typography>
    </Grid>
  );
};

export default TnC;
